import { Box, Typography, styled } from '@mui/material';

export const SearchFieldLabelWrapper = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(3),
  fontWeight: 600
}));

export const IntegrationListWrapper = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
  gridAutoRows: '1fr',
  gridColumnGap: '24px',
  gridRowGap: '24px'
}));
